<template>
  <div class="position-relative">
    <!-- Campo de fecha simple -->
    <InputDateDmy
      v-if="field.type === 'date' && !field.isArray && !field.time"
      :value="formatDateForInput(value)"
      :input-class="{
        'calculated-field': isLock(),
        'readonly-field': field.readonly,
      }"
      :hide-picker="isLock() || field.readonly"
      @input="onDateChange"
      @blur="onFieldBlur"
      @focus="onFieldFocus"
    />

    <!-- Campo de fecha y hora -->
    <input
      v-else-if="field.type === 'date' && !field.isArray && field.time"
      type="datetime-local"
      :value="formatDateTimeForInput(value)"
      @input="onDateTimeChange($event.target.value)"
      @change="onDateTimeChange($event.target.value)"
      @blur="onFieldBlur"
      @focus="onFieldFocus"
      class="form-control"
      :class="{
        'calculated-field': isLock(),
        'readonly-field': field.readonly,
      }"
    />
   <small class="text-danger" v-if="field.type === 'date' && !field.isArray && field.time">{{ $t('Empty time is not allowed') }}</small>
  </div>
</template>

<script>
import InputDateDmy from "./InputDateDmy.vue";

export default {
  name: "InputDate",
  components: { InputDateDmy },
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: [String, Date],
      default: null,
    },
    isLock: {
      type: Function,
      default: () => false,
    },
  },
  methods: {
    formatDateForInput(value) {
      if (!value) return "";

      // Las fechas ahora se manejan como texto simple
      if (typeof value === "string") {
        // Si ya es YYYY-MM-DD, devolverlo tal como está
        if (value.match(/^\d{4}-\d{2}-\d{2}$/)) {
          return value;
        }
        // Si es datetime, extraer solo la parte de fecha
        if (value.includes("T")) {
          return value.split("T")[0];
        }
      }

      // Si es un objeto Date (legacy), convertirlo a YYYY-MM-DD
      if (value instanceof Date) {
        const year = value.getFullYear();
        const month = String(value.getMonth() + 1).padStart(2, "0");
        const day = String(value.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      }

      return "";
    },

    onDateChange(value) {
      // Las fechas ahora se manejan como texto simple
      if (typeof value === "string") {
        // Si es datetime, extraer solo la parte de fecha
        if (value.includes("T")) {
          let valuedate = value.split("T")[0];
          this.$emit("input", valuedate);
        } else {
          this.$emit("input", value);
        }
      }
    },

    onDateTimeChange(value) {
      // Las fechas ahora se manejan como texto simple

      console.log("value", value);
      this.$emit("input", value);
    },

    formatDateTimeForInput(value) {
      if (!value) return "";

      // Las fechas con hora se manejan como texto simple
      if (typeof value === "string") {
        // Si ya está en formato YYYY-MM-DDTHH:mm, devolverlo tal como está
        if (
          value.includes("T") &&
          !value.includes("Z") &&
          !value.includes("+") &&
          !value.includes("-")
        ) {
          return value;
        }

        // Si es solo fecha, agregar T00:00 (solo si no había hora antes)
        if (value.match(/^\d{4}-\d{2}-\d{2}$/)) {
          const result = value + "T00:00";
          return result;
        }

        // Si tiene zona horaria, extraer solo la parte YYYY-MM-DDTHH:mm
        if (value.includes("Z") || value.includes("+") || value.includes("-")) {
          const match = value.match(/^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2})/);
          if (match) {
            return match[1];
          }
        }
      }

      // Si es un objeto Date (legacy), convertirlo a YYYY-MM-DDTHH:mm
      if (value instanceof Date) {
        const year = value.getFullYear();
        const month = String(value.getMonth() + 1).padStart(2, "0");
        const day = String(value.getDate()).padStart(2, "0");
        const hours = String(value.getHours()).padStart(2, "0");
        const minutes = String(value.getMinutes()).padStart(2, "0");
        const result = `${year}-${month}-${day}T${hours}:${minutes}`;
        return result;
      }

      return "";
    },

    onFieldBlur() {
      this.$emit("blur");
    },

    onFieldFocus() {
      this.$emit("focus");
    },
  },
};
</script>

<style scoped>
.form-control {
  padding: 0 7px !important;
}

::v-deep .readonly-field {
  background-color: #f8f9fa !important;
  border-color: #dee2e6 !important;
  color: #6c757d !important;
  cursor: not-allowed !important;
  opacity: 0.8;
}

::v-deep .calculated-field {
  background-color: #e3f2fd !important;
  border-color: #2196f3 !important;
  color: var(--bs-primary) !important;
  cursor: not-allowed !important;
}

::v-deep .readonly-field:focus {
  box-shadow: none !important;
  border-color: #dee2e6 !important;
}

::v-deep .readonly-field::placeholder {
  color: #adb5bd !important;
}
</style>
